import React from 'react';
import withStyles from "@material-ui/core/styles/withStyles";
import splasScreenStyle from "../../assets/jss/splashScreenStyle.jsx";

const SplashScreen = class extends React.Component {
    constructor(props){
        super(props);

        this.store = this.props.store;
    }  
    render() {
        const { classes } = this.props;
        const logoUrl = "/logosquare512.png";
        return (
            <div className={classes.overlay}>
                <img src={logoUrl}  alt="Loading" className={classes.loader}/>
            </div>
        )
    }
}

export default withStyles(splasScreenStyle)(SplashScreen);
